import { Hero } from "../sections/hero"
import { Product_Info } from "../sections/product-info"
import { Solution_Info } from "../sections/solution-info"

export const Solution_Page = () => {
    return (<>
       <Solution_Info />
    </>)
}